<template>
  <div class="text-xs-center data-table-histories" v-if="dataValue && dataValue.length > 0">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        <v-layout row>
          <v-flex md10 text-md-left>
            Histórico do Ciclo
          </v-flex>
          <v-flex md2 text-md-right>
            <v-btn flat icon color="primary" @click="downloadDataTable()">
              <v-icon>cloud_download</v-icon>
            </v-btn>
            <v-btn flat icon color="primary" @click="printDataTable()">
              <v-icon>print</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>

      <v-card-text>
        <v-layout row>
          <v-flex md12>
            <v-data-table
              :headers="headers"
              :items="dataValue"
              hide-actions
              :total-items="dataValue.length"
              rows-per-page-text="Linhas por Página">
              <template slot="items" slot-scope="props">
                <td class="td-align-left">#{{ props.item.id }}</td>
                <td class="td-align-left">{{ props.item.title }}</td>
                <td class="td-align-left">{{ props.item.called_status.description }}</td>
                <td class="td-align-left">{{ props.item.priority.description }}</td>
                <td class="td-align-left">{{ props.item.created_at | prDate }}</td>
                <td class="td-align-left">{{ props.item.total_worked_hours }}h</td>
              </template>
              <template slot="pageText" slot-scope="props">
                {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>       
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions v-if="isDialog">
        <v-spacer></v-spacer>
        <v-btn color="error" flat @click="closeDialog()">
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import DialogMixin from '@/components/mixins/DialogMixin';
import ReportService from '@/features/report/ReportService';

export default {
  name: 'data-table-called-history',
  mixins: [DialogMixin],
  props: {
    dataValue: {
      required: true,
    },
    cycleId: {
      required: true,
    },
    isDialog: false,
  },
  data() {
    return {
      headers: [
        {
          text: 'Chamado Nº',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Chamado',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Status',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Prioridade',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Data',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Horas Alocadas',
          sortable: false,
          align: 'left',
        },
      ],
      reportService: new ReportService(),
    };
  },
  methods: {
    convertMinutesToHours(value) {
      let hourAndMinutes = '--:--';
      if (value) {
        const hours = (Math.floor(value / 60)).toString().padStart(2, '0');
        const minutes = (value % 60).toString().padStart(2, '0');
        hourAndMinutes = `${hours}:${minutes}`;
      }
      return hourAndMinutes;
    },
    printDataTable() {
      window.print();
    },
    downloadDataTable() {
      const queryParams = { params: { cycle_id: this.cycleId } };
      this.reportService.request('GET', 'generate-pdf', null, queryParams).then((response) => {
        this.downloadPDF(response.data.filePath);
      });
    },
    async downloadPDF(filePath) {
      const downloadOpts = {
        responseType: 'blob',
        params: { filePath },
      };
      const res = await this.reportService.request('GET', 'download-pdf', null, downloadOpts);
      const file = new Blob([res.data], { type: res.headers['content-type'] });
      const a = window.document.createElement('a');
      a.href = window.URL.createObjectURL(file);
      const fileName = filePath.split('__');
      a.download = fileName[(fileName.length - 1)];
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },
};
</script>
<style>
  .data-table-histories {
    width: 100%;
  }
  .td-align-left {
    text-align: left;
  }
  .input-file {
    display: none;
  }
  .quill-editor:not(.bubble) .ql-container,
  .quill-editor:not(.bubble) .ql-container .ql-editor {
    height: 15rem !important;
    padding-bottom: 1rem;
  }
  .date-label {
    height: 20px !important;
  }
</style>


// WEBPACK FOOTER //
// src/features/report/DataTableCalledHistory.vue